import { makeStyles, withStyles } from '@material-ui/core/styles';
import StepConnector from '@material-ui/core/StepConnector';

const black = '#000';
const white = '#fff';
const lightGray = '#C2C2C2';
// const darkGray = '#929292';
const bgColor = '#fafafa';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        color: '#000',
        width:'100%',
        justifyContent: 'center',
        [theme.breakpoints.down('1024')]: {
            height: 'inherit'
        }
    },
    formRoot: {
        width: '62.71%',
        [theme.breakpoints.down('sm')]: {
            width: '100vw'
        }
    },
    title: {
        marginTop: '68px',
        marginBottom: '64px',
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#fafafa',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            marginBottom: '40px',
            marginTop: '47px'
        },
        [theme.breakpoints.down('767')]: {
            marginBottom: 0
        },
        [theme.breakpoints.between('sm', 'md')]: {
            fontSize: '32px'
        },
        [theme.breakpoints.between('md', 'lg')]: {
            fontSize: '36px'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '40px'
        },
    },
    form: {
        width: '100%',
        margin: '0 auto'
    },
    stepper: {
        width: '310px',
        marginBottom: '64px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '1px',
        backgroundColor: '#fafafa',
        [theme.breakpoints.only('sm')]: {
            marginBottom: '32px',
        },
    },
    stepIcon: {
        color: '#fff',
        fontSize: '35px',
        borderRadius: '50%',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%)',
        '& text': {
            fill: '#C2C2C2',
            fontSize: '10px'
        }
    },
    alternativeLabel: {
        textTransform: 'uppercase',
        fontWeight: 'bold !important',
        color: '#ADADAD'
    },
    activeIcon: {
        fill: '#000',
        '& text': {
            fill: '#fff'
        }
    },
    completedIcon: {
        color: "#000"
    },
    inputContainer: {
        width: '310px',
        margin: '0 auto',
        marginBottom: '77px',
        backgroundColor: '#fafafa',
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 20px)',
            marginLeft: '10px',
            marginRight: '10px'
        },
        '& input, & textarea': {
            fontSize: '14px',
            fontWeight: '500'
        },
        '& .MuiBox-root': {
            width: '100%'
        }
    },
    inputTitleContainer: {
        backgroundColor: '#fafafa',
        marginBottom: '8px',
        [theme.breakpoints.down('345')]: {
            marginLeft: '10px',
            marginRight: '10px'
        }
    },
    inputTitleText: {
        fontWeight: 'bold',
        fontSize: '16px'
    },
    inputFieldContainer: {
        width: 'calc(100% - 32px)',
        maxHeight: '30px',
        margin: '0',
        marginBottom: '32px',
        backgroundColor: '#fff',
        borderColor: '#fafafa',
        borderRadius: '11px',
        padding: '14px 16px',
        '& input': {
            width: 'auto'
        },
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%)',
        '& button': {
            padding: '0'
        },
        '& .MuiFormHelperText-root.Mui-error': {
            position: 'relative',
            top: '-9px'
        }
    },
    smIconsContainer: {
        backgroundColor: 'inherit',
        marginBottom: '32px',
        '& svg': {
            fontSize: '30px',
            padding: '12px 12px 0 12px',
            '&:first-child': {
                paddingLeft: '0'
            },
            '&:last-child': {
                paddingRight: '0'
            }
        }
    },
    nextButton: {
        fontWeight: 'bold',
        borderRadius: '20px',
        height: '40px',
        paddingLeft: '24px',
        paddingRight: '16px',
        '&:disabled': {
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.32)',
        },
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '& svg': {
            position: 'relative',
            left: '8px',
            [theme.breakpoints.down('332')]: {
                left: '2px'
            },
        },
        '&:only-child': {
            margin: '0 auto'
        },
        [theme.breakpoints.down('332')]: {
            paddingRight: '12px',
            paddingLeft: '20px'
        },
    },
    prevButton: {
        width: '310px',
        height: '40px',
        marginBottom: '27px',
        fontWeight: 'bold',
        borderRadius: '20px',
        marginTop: 0,
        paddingRight: '24px',
        paddingLeft: '16px',
        color: black,
        boxShadow: 'none !important',
        '& svg': {
            position: 'relative',
            right: '8px',
            [theme.breakpoints.down('332')]: {
                right: '2px'
            }
        },
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 20px)',
            marginLeft: '10px',
            marginRight: '10px'
        },
        [theme.breakpoints.down('332')]: {
            paddingRight: '20px',
            paddingLeft: '12px'
        }
    },
    fullWidthButton: {
        fontWeight: 'bold',
        borderRadius: '20px',
        width: '310px',
        height: '40px',
        marginTop: 0,
        marginBottom: '27px',
        paddingLeft: '24px',
        paddingRight: '16px',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '& a': {
            textDecoration: 'none'
        },
        '& a.MuiLink-underlineHover': {
            textDecoration: 'none'
        },
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 20px)',
            marginLeft: '10px',
            marginRight: '10px'
        }
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
        width: '310px',
        margin: '0 auto',
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 20px)',
            marginLeft: '10px',
            marginRight: '10px'
        }
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    inviteDownloadContainer: {
        backgroundColor: bgColor,
        padding: '0 !important',
        width: '100%',
        margin: 0
    },
    noPadding: {
        padding: '0 !important'
    },
    wrapFields: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '52px',
        [theme.breakpoints.down('385')]: {
            marginLeft: '10px',
            marginRight: '10px'
        }

    },
    mobileContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        width: '100%',
        paddingTop: '4px',
        fontSize: '14px',
        fontWeight: 'bold',
        fontFamily: 'Poppins',
        backgroundColor: bgColor
    },
    mobileStepLabel: {
        display: 'inherit',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
        fontFamily: 'inherit',
        '& p': {
            fontSize: 'inherit',
            fontWeight: 'inherit',
            marginLeft: '10px',
            // textTransform: 'uppercase'
        },
        '& div': {
            display: 'inline-block',
            padding: 0,
            '&:first-letter': {
                color: white,
                backgroundColor: black,
                borderRadius: '50%',
                padding: '0 6px'
            },
        }
    },
    linkContainer: {
        width: '100%',
        marginTop: 0
    },
    copyContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        '& p': {
            fontSize: '14px',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 50px)',
            marginLeft: '10px',
            marginRight: '10px'
        }
    },
    copyBtn: {
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '1.5',
        paddingLeft: '10px'
    },
    bgColor: {
        backgroundColor: bgColor
    },
    mb8: {
        marginBottom: '8px'
    },
    mb26: {
        marginBottom: '26px !important'
    },
    mb40: {
        marginBottom: '40px !important'
    },
    mb70: {
        marginBottom: '70px'
    },
    mt56: {
        marginTop: '56px'
    },
    noMaxHeight: {
        maxHeight: 'none'
    },
    checkbox: {
        '& span.MuiFormControlLabel-label': {
            fontSize: '16px',
            fontWeight: '600'
        },
        '& span.MuiFormControlLabel-label label a': {
            textDecoration: 'none',
            color: 'rgb(18, 42, 255)'
        },
        marginBottom: '10px',
        '& span.MuiCheckbox-root': {
            color: black
        },
        '& .MuiIconButton-label': {
            width: '30px',
            height: '30px',
            color: 'transparent',
            borderRadius: '8px',
            boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        },
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 10px)',
            marginLeft: '1px',
            marginRight: '10px'
        }
    },
    subTitle: {
        fontSize: '14px',
        color: lightGray,
        marginTop: '2px',
        fontWeight: 600,
        marginBottom: '40px'
    },
    center: {
        display: 'block',
        margin: '0 auto',
        marginBottom: '26px'
    },
    checkboxContainer: {
        width: '310px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 20px)',
            marginLeft: '10px',
            marginRight: '10px'
        }
    },
    checkboxSingle: {
        color: 'green',
        width: 'auto',
        height: '48px',
        color: black,
        backgroundColor: white,
        margin: '0 0 9px 0',
        padding: '0 17px',
        borderRadius: '10px',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '& span': {
            fontSize: '14px',
            fontWeight: 'bold'
        },
        '&.selected': {
            backgroundColor: '#122AFF',
            color: '#fff'
        }
    },
    hideCheckbox: {
        visibility: 'hidden',
        width: 0,
        height: 0,
        padding: 0
    },
    list: {
        width: 'inherit',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: 0,
        marginBottom: '65px',
        '& li': {
            listStyle: 'none',
            marginBottom: '16px'
        },
        '& svg': {
            marginRight: '14px'
        },
        [theme.breakpoints.down('345')]: {
            width: 'calc(100% - 20px)',
            marginLeft: '10px',
            marginRight: '10px'
        }
    },
    providerTypeContainer: {
        position: 'relative',
        display: 'inline-block'
    },
    img: {
        marginTop: '32px',
        marginBottom: '72px'
    }
}));

const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 14
    },
    active: {
      '& $line': {
        backgroundColor: '#000'
      },
    },
    completed: {
      '& $line': {
        backgroundColor: '#000'
      },
    },
    line: {
      height: 5,
      border: 0,
      backgroundColor: '#fff',
      borderRadius: 1,
      boxShadow: '0 3px 6px 0 rgb(0 0 0 / 7%)',
    },
})(StepConnector);

export { useStyles, ColorlibConnector };